import { Suspense, forwardRef, useEffect } from "react";
import { Canvas } from "@react-three/fiber";
import { OrbitControls, PerspectiveCamera } from "@react-three/drei";
import { ErrorBoundary } from "react-error-boundary";
import { useCameraPosition } from "hooks/useCameraPosition";
import { useModel } from "hooks/useModel";

export interface AssetPreviewProps {
  modelUrl: string;
  onLoad?: (model: ReturnType<typeof useModel>) => void;
  fillPercentage: number;
}

const AssetPreview = forwardRef<HTMLCanvasElement, AssetPreviewProps>(({ modelUrl, onLoad = () => {}, fillPercentage }, ref) => {
  const model = useModel({ url: modelUrl });
  const { cameraPosition, containerRef, cameraTarget: target } = useCameraPosition({ ...model, fillPercentage });

  useEffect(() => {
    onLoad(model);
  }, [model]);

  return (
    <div ref={containerRef as any} className="w-full h-full">
      <ErrorBoundary fallback={null}>
        <Suspense>
          <Canvas gl={{ preserveDrawingBuffer: true }} ref={ref}>
            <ambientLight intensity={1} />
            <directionalLight intensity={0.5} position={[1, 1, 1]} />
            <directionalLight intensity={0.5} position={[-1, -1, -1]} />
            <PerspectiveCamera near={0.01} makeDefault position={cameraPosition}></PerspectiveCamera>
            <primitive object={model.scene}></primitive>
            <OrbitControls target={target}></OrbitControls>
          </Canvas>
        </Suspense>
      </ErrorBoundary>
    </div>
  );
});

export default AssetPreview;
